/* eslint-disable func-names */
import { SHOW_CONFIRM_MODAL, HIDE_MODAL, CHANGE_CURRENT_PAGE, SAVE_WEATHER_DATA } from './types';

const INITIAL_STATE = {
  currentModule: 'Airport Portal',
  weather: {}
};


export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SHOW_CONFIRM_MODAL:
      return {
        ...state,
        modalProps: {
          ...action.payload
        },
        modalType: 'SHOW_CONFIRM_MODAL'
      };
    case HIDE_MODAL:
      return {
        ...state,
        modalType: undefined
      };
    case CHANGE_CURRENT_PAGE:
      return {
        ...state,
        currentModule: action.payload
      };
    case SAVE_WEATHER_DATA:
      return {
        ...state,
        weather: action.payload
      };
    default:
      return state;
  }
}
